import { DotLoader } from 'react-spinners'

interface LoadingOverlayProps {
  show: boolean
  message?: string
}

export const LoadingOverlay = ({ show }: LoadingOverlayProps) => {
  if (!show) return null

  return (
    <div className="loading-overlay">
      <DotLoader 
        color="var(--irogami-primary)" 
        size={40}
        speedMultiplier={1}
      />
    </div>
  )
}

